import { render, staticRenderFns } from "./LeaderBoardProgressbar.vue?vue&type=template&id=55bbb60c&scoped=true&"
import script from "./LeaderBoardProgressbar.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardProgressbar.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardProgressbar.vue?vue&type=style&index=0&id=55bbb60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bbb60c",
  null
  
)

export default component.exports